import { exists } from '@/helpers/utilities';
import DismissCookie from '@/modules/DismissCookie';

let AlertBar = (({}) => {
    class AlertBar {
        constructor(node, selector) {
            this.node = node;
            this.selector = selector;
            this.nodeExists = exists(this.node);
        
            if (!this.nodeExists) return;
        
            this.cookie = new DismissCookie( this.node.dataset.id );
            this.spacer = this.node.previousElementSibling;
            this.closeBtn = this.node.querySelector(`[data-js="close-btn"]`);
            this.hasDismissCookie = document.cookie.indexOf(`${this.cookie.cookieName}=`) !== -1;
            
            
            
            
            const currentDatetime = Math.floor(Date.now() / 1000);
            const beginsDatetime = parseInt(this.node.dataset.begins) || 0;
            const endsDatetime = parseInt(this.node.dataset.ends) || 0;
            
            // 1. Current time must be >= start time.
            // 2. If end time is 0, it's valid. Otherwise, current time must be <= end time.
            const isAfterStart = currentDatetime >= beginsDatetime;
            const isBeforeEnd = (endsDatetime === 0) || (currentDatetime <= endsDatetime);
            
            this.isActive = isAfterStart && isBeforeEnd;

            
            
            
            console.log('current: ' + currentDatetime);
            console.log('begins: ' + beginsDatetime);
            console.log('ends: ' + endsDatetime);
            
        }
        
        get tabbableElements() {
            return this.node
                ? this.node.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]')
                : [];
        }
        
        disableTabIndex() {
            this.tabbableElements.forEach(function(element) {
                element.setAttribute('tabindex', '-1');
            });
        }
        
        enableTabIndex() {
            this.tabbableElements.forEach(function(element) {
                element.setAttribute('tabindex', '0');
            });
        }
        
        showNode() {
            this.node.classList.remove('js-is-hidden');
        }

        hideNode() {
            this.node.classList.add('js-is-hidden');
            this.node.classList.remove('js-is-loaded');
            this.spacer.style.maxHeight = '0px';
            document.documentElement.style.setProperty('--alert-bar-spacer-height', '0px');
            this.node.style.maxHeight = '0px';
            this.tabbableElements.forEach(function(element) {
                element.setAttribute('tabindex', '-1');
            });
        }

        grabHeight() {
            this.spacer.style.maxHeight = 'none';
            this.nodeHeight = this.node.getBoundingClientRect().height;
            this.spacer.style.maxHeight = '0px';
        }
        
        updateHeight() {
            if (this.node.classList.contains('js-is-loaded')) {
                const currentHeight = this.node.getBoundingClientRect().height;
                const spacerCurrentMaxHeight = parseFloat(this.spacer.style.maxHeight) || 0;
        
                // Only update if the height has changed
                if (currentHeight !== spacerCurrentMaxHeight) {
                    this.spacer.style.maxHeight = `${currentHeight}px`;
                }
            }
        }

        doDelayReveal() {
            this.node.classList.remove('js-is-hidden');
            this.node.classList.add('js-is-loaded');
            this.enableTabIndex();
            setTimeout(() => {
                this.spacer.style.maxHeight = `${this.nodeHeight}px`;

                setTimeout(() => {
                    this.node.classList.add('js-is-ready');
                }, 400);
            }, 300);
        }

        onWindowLoad() {
            this.doDelayReveal();
        }

        onTransitionEnd() {
            window.dispatchEvent( new CustomEvent( 'forceNavOffset' ) );
        }

        onCloseBtnClick(e) {
            e.stopPropagation();
            this.disableTabIndex();
            this.hideNode();
            this.cookie.setCookie();
        }
        
        // clean up the DOM if a cookie hides the alert
        removeElements() {
            if (this.spacer) this.spacer.remove();
            if (this.node) this.node.remove();
        }

        setEventBindings() {
            window.addEventListener('load', this.onWindowLoad.bind(this));
            window.addEventListener('resize', this.updateHeight.bind(this));
            this.node.addEventListener( 'transitionend', this.onTransitionEnd.bind(this) );
            this.closeBtn.addEventListener('click', this.onCloseBtnClick.bind(this));
        }

        init() {
            if (!this.nodeExists) return;
        
            if (!this.isActive) {
                this.removeElements();
                return;
            }
        
            if (this.hasDismissCookie) {
                this.removeElements();
                return;
            }
        
            this.disableTabIndex();
            this.grabHeight();
            this.setEventBindings();

            if (document.readyState === 'complete') {
                this.onWindowLoad();
            }
        }

    }

    return {
        init({ selector }) {
            let nodeList = document.querySelectorAll(selector);
            if (!nodeList.length) return;

            return [...nodeList].map((node) => {
                let module = new AlertBar(node, selector);

                module.init();

                return module;
            });
        },
    };
})(window);

export default Object.create(AlertBar);
